import styled from 'styled-components';
import { fonts } from '../components/Styling';

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: ${fonts.sans};
  transform-style: preserve-3d;
  * {
    transform-style: preserve-3d;
  }

  &:after {
    background-color: black;
    content: '';
    height: 400vh;
    left: -50vw;
    opacity: ${props => props.dim ? 0.75 : 0};
    pointer-events: ${props => props.dim ? 'initial' : 'none'};
    position: fixed;
    top: -100vh;
    transition: opacity 0.2s;
    width: 400vw;
    z-index: 99;
    transform: translateZ(1px);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Grid.js